import { HttpErrorResponse } from '@angular/common/http';
import { Component, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { App, NavController, NavParams } from 'ionic-angular';
import { Storage } from '../../../node_modules/@ionic/storage';
import { TranslateService } from '../../../node_modules/@ngx-translate/core';
import { AuthenticationService } from '../../providers/authentication/authenticationService';
import { Config } from '../../providers/config';
import { ConfigService } from '../../providers/config/config.service';
import { NavControllerService } from '../../providers/nav-controller/navControllerService';
import { PaytronBackendService } from '../../providers/paytron-backend/paytron-backend.service';

@Component({
  selector: 'page-card-reader-login',
  templateUrl: 'card-reader-login.html',
})
export class CardReaderLoginPage {
  @ViewChild('loginForm')
  private loginForm: NgForm;

  isLoginByUsernameEnabled: boolean = false;

  error = null;
  apiVersion = 'loading';
  private currentConfiguration: Config;
  private navControllerService: NavControllerService;
  cardReaderError = null;

  private cardReaderWebSocket: WebSocket;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private backendService: PaytronBackendService,
    private authenticationService: AuthenticationService,
    public translate: TranslateService,
    private storage: Storage,
    public configService: ConfigService,
    private app: App
  ) {
    this.navControllerService = new NavControllerService(app, storage);
    this.translate.setDefaultLang('it');
    this.translate.use(this.translate.getBrowserLang());
    this.storage.set('lang', this.translate.getBrowserLang());
    this.currentConfiguration = this.configService.getConfiguration();
    if (this.navParams.get('isSessionTimeout')) {
      this.error = 'isSessionTimeout';
    }
    backendService.isSetupUserAvailable().subscribe((isSetupUserAvailable: boolean) => {
      this.isLoginByUsernameEnabled = isSetupUserAvailable;
    });
    backendService.ping().subscribe(
      (apiVersion: string) => {
        this.apiVersion = apiVersion;
      },
      (error: any) => {
        this.apiVersion = 'error';
      }
    );
  }

  ionViewDidLoad() {
    this.cardReaderWebSocket = this.initCardReaderWebSocket();
  }
  
  ionViewDidLeave() {
    if (this.cardReaderWebSocket.readyState == WebSocket.OPEN) {
      this.sendCardReaderHaltCommand();
    }
    this.cardReaderWebSocket.close();
  }

  private initCardReaderWebSocket(): WebSocket {
    let cardReaderWebSocket: WebSocket = new WebSocket(this.configService.getCardReaderWebSocketUrl());
    cardReaderWebSocket.addEventListener('error', (ev: Event) => {
      if (cardReaderWebSocket.readyState == WebSocket.CLOSED) {
        this.cardReaderError = 'notFound';
      } else if (cardReaderWebSocket.readyState == WebSocket.CONNECTING) {
        this.cardReaderError = 'stillConnecting';
      } else {
        this.cardReaderError = 'genericError';
        console.error('Card reader error %o', ev);
      }
    });
    cardReaderWebSocket.addEventListener('open', (ev: Event) => {
      this.cardReaderError = null;
      this.sendCardReaderHaltCommand();
    });
    cardReaderWebSocket.addEventListener('message', (ev: MessageEvent) => {
      let evData: any = JSON.parse(ev.data);
      switch (evData.messageType) {
        case 'event':
          switch (evData.message.event) {
            case 'UNPROTECTED_CARD_DETECTED':
              this.sendCardReaderHaltCommand();
              break;
            case 'CARD_DETECTED':
              this.loginForm.value.cardName = null;
              this.loginForm.value.username = null;
              this.sendCardReaderHaltCommand();
              this.authenticationService.getCardLoginData(evData.message.values.cardId).subscribe(
                (response) => {
                  this.loginForm.value.cardName = response.cardName;
                  this.loginForm.value.username = response.userName;
                },
                (err: HttpErrorResponse) => {}
              );
              break;
          }
          break;
      }
    });
    return cardReaderWebSocket;
  }

  private sendCardReaderHaltCommand() {
    this.cardReaderWebSocket.send(
      JSON.stringify({
        messageType: 'command',
        message: {
          command: 'HALT',
        },
      })
    );
  }

  login(loginForm: NgForm) {
    this.authenticationService.login(loginForm.value.username, loginForm.value.password).subscribe(
      (response) => {
        let authority = response && response.user && response.user.authorities[0];
        this.storage.set('userRole', authority).then(() => {
          switch (authority) {
            case 'ROLE_INSTALLATORE':
              this.navControllerService.showPosPage();
              break;
            case 'ROLE_SETUP':
            case 'ROLE_TESORIERE':
              this.navControllerService.showUsersPage();
              break;
            case 'ROLE_RICEVIMENTO':
            case 'ROLE_ADMIN':
              this.navControllerService.showCustomersPage();
              break;
            default:
              this.navControllerService.showCardReaderLoginPage();
              break;
          }
        });
      },
      (err: HttpErrorResponse) => {
        if (err.status == 401) {
          this.error = 401;
        }
        if (err.status == 0) {
          this.error = 0;
        }
      }
    );
  }

  showLoginPage() {
    this.navControllerService.showLoginPage();
  }
}



// WEBPACK FOOTER //
// ./src/pages/card-reader-login/card-reader-login.ts